/**
 * main.ts
 *
 * Bootstraps Vuetify and other plugins then mounts the App`
 */

// Plugins
import { registerPlugins } from "@/plugins";

// Components
import App from "./App.vue";

// Composables
import { createApp } from "vue";
import { createGtag } from "vue-gtag";
import router from "@/router";

import * as Sentry from "@sentry/vue";
import { logBuildVersion } from "@/utils/buildVersion";
import { dropExpectedBusinessErrors } from "@/utils/expectedErrors";
import { networkFailuresAsBreadcrumbs } from "@/utils/networkErrors";
import { sentryRuntimeOptions } from "@/utils/sentryConfig";

// Log build version on startup
logBuildVersion();

const app = createApp(App);

registerPlugins(app);

createGtag({
  tagId: "G-T6ZX5JD3Z1",
  pageTracker: {
    router,
  },
});

Sentry.init({
  app,
  dsn: "https://83a2e1a7e6981c406708acfd5c78e2ed@o4509084278784000.ingest.us.sentry.io/4509084279832576",
  // Off on the dev server and on localhost; environment = Vite mode.
  ...sentryRuntimeOptions({
    hostname: window.location.hostname,
    mode: import.meta.env.MODE,
    prod: import.meta.env.PROD,
  }),
  ignoreErrors: [
    /unauthenticated/i,
    /zaloJSV2/i,
    /account expired/i,
    /user not found/i,
    /Unable to preload CSS for/i,
    /Failed to fetch dynamically imported module/i,
    /Importing a module script failed/i,
  ],
});

// "Failed to fetch" / "Load failed" / offline: a breadcrumb, not an error.
Sentry.addEventProcessor(networkFailuresAsBreadcrumbs);
// Session expired, not found, invalid input, …: shown to the user, not reported.
Sentry.addEventProcessor(dropExpectedBusinessErrors);

app.mount("#app");
